import React from "react";
import {
  //   LinearProgress,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
  Button,
  Backdrop,
} from "@mui/material";
import { useEffect, useState } from "react";
import http from "../../utils/http";
import { errorToastMessage, toastMessage } from "../../utils/toast";
import {
  NoDataContainer,
  StyledTableCell,
  TableBorderRadiusTopLeftRight,
} from "../Common/styles/table";
import { Add, MoreVert } from "@mui/icons-material";
import { AxiosResponse } from "axios";
import { useNavigate, useParams } from "react-router-dom";
// import AddEConsentModal from "./AddEConsentModal";
import { DateTime } from "luxon";
import StatusBadge from "../Common/UI/StatusTag";
import AddScreeningFormModal from "./AddScreeningFormModal";
import DeleteConfirmModal from "../Common/UI/DeleteConfirm";
import LanguageTranslationModal from "./LanguageTranslationModal";
import CopyFormModal from "./CopyFormModal";
import Loader from "../Common/assets/Loader";
import AddTemplateModal from "./AddTemplateModal";
import { Languages } from "../../Redux/reducers/studySlice";

const statusMap: any = {
  draft: { label: "Draft", variant: "completed" },
  active: { label: "Active", variant: "active" },
  inactive: { label: "Inactive", variant: "cancelled" },
};

type Props = {
  canEdit: boolean;
  canExport: boolean;
  languages: Languages[];
  type: "platform" | "study";
};

const Screening = ({ canEdit, canExport, type, languages }: Props) => {
  const { id: studyId } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState<any>([]);
  const [phaseId, setPhaseId] = useState("");
  const [rowData, setRowData] = useState<any>(null);

  const [loading, setLoading] = useState<boolean>(false);
  const [toggleLoader, setToggleLoader] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [deleteConfirmation, setDeleteConfirmation] = useState<{
    title: string;
    description: string;
  }>({
    title: "",
    description: "",
  });

  const [showModal, setShowModal] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const prefix =
          type === "platform" ? "/admin/registry/" : `/study/${studyId}/`;
        const phase = type === "platform" ? "registry-phase" : "study-phase";
        const url = `${prefix}${phase}?category=screening`;
        const res: AxiosResponse = await http.get(url);
        const data = res.data?.data?.[0];
        if (data) {
          const phaseRes: AxiosResponse = await http.get(
            `${prefix}${phase}/${data?.id}`
          );
          const phaseData = phaseRes.data?.data;

          const statusOrder: { [key: string]: number } = {
            active: 1,
            draft: 2,
            inactive: 3,
          };

          const formattedData = (phaseData?.phaseForms || [])
            .map((item: any) => {
              return {
                id: item?.id,
                name: item?.form?.name || "",
                description: item?.form?.description || "",
                formId: item?.form?.id || "",
                status: item?.form?.status || "",
                questionCount: item?.form?.questionCount || 0,
                createdAt: item?.form?.createdAt
                  ? DateTime.fromISO(item?.form?.createdAt).toFormat(
                      "MM/dd/yyyy"
                    )
                  : "",
                position: item?.position,
              };
            })
            .sort((a: any, b: any) => {
              const statusComparison =
                (statusOrder[a.status] || 999) - (statusOrder[b.status] || 999);
              if (statusComparison !== 0) {
                return statusComparison;
              }
              return a.position - b.position;
            });

          setData(formattedData);

          setPhaseId(phaseData?.id || "");
        } else {
          setData([]);
          setPhaseId("");
        }
        setLoading(false);
      } catch (err) {
        setLoading(false);
        errorToastMessage(err as Error);
      }
    };
    fetchData();
  }, [studyId, toggleLoader, type]);

  //   const handleActionClick = useCallback(
  //     async (action: string) => {
  //       try {
  //         let url: string = `/admin/study/${studyId}/econsent/${selectedRow?.consentId}/versions/${selectedRow?.id}`;
  //         let body: any = null;
  //         let res: AxiosResponse;
  //         setMenuLoader(action);

  //         if (action === "delete") {
  //           res = await http.delete(url);
  //         } else {
  //           url += `/status`;
  //           body = {
  //             status:
  //               selectedRow?.status === "draft"
  //                 ? "active"
  //                 : selectedRow?.status === "active"
  //                 ? "inactive"
  //                 : "active",
  //           };
  //           res = await http.post(url, body);
  //         }
  //         handleMenuClose();
  //         toastMessage("success", res?.data?.message);
  //         setMenuLoader("");
  //         refreshPage();
  //       } catch (err) {
  //         errorToastMessage(err as Error);
  //         setMenuLoader("");
  //       }
  //     },
  //     [studyId, selectedRow, setMenuLoader]
  //   );

  const openModal = async (name: string) => {
    if (name !== "print") {
      setShowModal(name);
    } else {
      try {
        await http.post(`/study/${studyId}/print?type=screening`);
        window.open(`/print/study/${studyId}/phase/screening`, "_blank");
      } catch (err) {
        errorToastMessage(err as Error);
      }
    }
    setAnchorEl(null);
  };

  const closeModal = () => {
    setShowModal("");
    setRowData(null);
  };

  const refreshPage = () => {
    setToggleLoader((prev) => !prev);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, row: any) => {
    setRowData(row);
    setAnchorEl(event.currentTarget);
    setDeleteConfirmation({
      title: "Delete Form ?",
      description: `Are you sure you want to delete ${row?.name} ?`,
    });
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setRowData(null);
  };

  const printForm = async () => {
    try {
      setAnchorEl(null);
      const formId = rowData?.formId;
      setRowData(null);
      await http.post(`/study/${studyId}/print?type=form&formId=${formId}`);
      window.open(`/print/study/${studyId}/form/${formId}`, "_blank");
    } catch (err) {
      errorToastMessage(err as Error);
    }
  };

  const handleExport = async () => {
    try {
      setLoading(true);
      const selectedForms = {
        screeningPhaseIds: [phaseId],
        screeningFormsIds: [rowData?.formId],
      };
      const body = {
        selectedForms: selectedForms,
        exportData: "all",
      };
      let res;
      res = await http.post(`/study/${studyId}/exports`, body);
      toastMessage("success", res.data.message);
      handleMenuClose();
      setLoading(false);
    } catch (err) {
      errorToastMessage(err as Error);
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const prefix =
        type === "platform" ? "/admin/registry/" : `/study/${studyId}/`;
      const phase = type === "platform" ? "registry-phase" : "study-phase";
      let url = `${prefix}${phase}`;
      let message: string = "";
      url += `/${phaseId}/phase_form/${rowData?.id}`;

      await http.delete(url);
      refreshPage();
      message = "Form deleted successfully";
      setShowDeleteModal(false);
      handleMenuClose();
      toastMessage("success", message);
    } catch (err) {
      errorToastMessage(err as Error);
      setLoading(false);
    }
  };

  const handleActivate = async () => {
    try {
      setLoading(true);
      const prefix =
        type === "platform" ? "/admin/registry/" : `/study/${studyId}/`;
      const phase = type === "platform" ? "registry-phase" : "study-phase";
      let url = `${prefix}${phase}/${phaseId}/form/${rowData?.formId}/status`;

      await http.patch(url);
      refreshPage();
      handleMenuClose();
      toastMessage("success", "Form activated successfully");
    } catch (err) {
      errorToastMessage(err as Error);
      setLoading(false);
    }
  };

  const handlePreviewClick = (formId: string) => {
    sessionStorage.setItem("selected-phase-id", phaseId);
    if (type === "platform") {
      navigate(`/app/designer/form/${formId}/preview`);
    } else {
      navigate(`/studies/${studyId}/study-designer/form/${formId}/preview`);
    }
  };

  return (
    <Box
      sx={{
        height: "calc(100vh - 184px)",
        overflow: "auto",
        m: -2.5,
        p: 2.5,
      }}
    >
      {loading && (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      )}
      <Box
        sx={{
          p: 2,
          backgroundColor: "#fff",
          borderRadius: "10px",
        }}
      >
        {canEdit && (
          <Box
            sx={{
              mb: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              minHeight: "40px",
            }}
          >
            <Button
              variant="outlined"
              startIcon={<Add />}
              onClick={() => openModal("addForm")}
            >
              Add Form
            </Button>
          </Box>
        )}
        <Table sx={TableBorderRadiusTopLeftRight}>
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ minWidth: 140 }}>
                Questionnaire Name
              </StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell sx={{ minWidth: 200 }}>
                Creation Date
              </StyledTableCell>
              <StyledTableCell />
            </TableRow>
          </TableHead>
          {data?.length > 0 && (
            <>
              <TableBody>
                {data?.map((row: any) => (
                  <TableRow key={row?.id}>
                    <StyledTableCell
                      sx={{ cursor: "pointer" }}
                      onClick={() => handlePreviewClick(row?.formId)}
                    >
                      {row?.name || "-"}
                    </StyledTableCell>

                    <StyledTableCell>
                      <StatusBadge
                        label={statusMap[row?.status]?.label ?? row?.status}
                        variant={statusMap[row?.status]?.variant}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row?.createdAt || "-"}</StyledTableCell>

                    <StyledTableCell align="right">
                      <IconButton onClick={(e) => handleMenuClick(e, row)}>
                        <MoreVert />
                      </IconButton>
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </>
          )}
        </Table>
        {!loading && data?.length === 0 && (
          <NoDataContainer>
            <Typography variant="body1" color="gray">
              No Data
            </Typography>
          </NoDataContainer>
        )}
        {/* {loading && (
          <Box sx={{ width: "100%" }}>
            <LinearProgress />
          </Box>
        )} */}

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          TransitionProps={{
            exit: false,
          }}
        >
          {canEdit && rowData?.status === "draft" && (
            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                handleActivate();
              }}
            >
              <ListItemText>Activate Form</ListItemText>
            </MenuItem>
          )}
          {canEdit && (
            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                openModal("editForm");
              }}
            >
              <ListItemText>Edit Form</ListItemText>
            </MenuItem>
          )}
          {type !== "platform" && (
            <MenuItem onClick={printForm}>
              <ListItemText>Print Form</ListItemText>
            </MenuItem>
          )}
          {canEdit && rowData?.status === "draft" && (
            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                sessionStorage.setItem("selected-phase-id", phaseId);
                if (type === "platform") {
                  navigate(`/app/designer/form/${rowData?.formId}/edit`);
                } else {
                  navigate(
                    `/studies/${studyId}/study-designer/form/${rowData?.formId}/edit`
                  );
                }
              }}
            >
              <ListItemText>Open in form editor</ListItemText>
            </MenuItem>
          )}
          {canEdit && (
            <MenuItem
              onClick={() => {
                if (rowData.questionCount > 0) {
                  setAnchorEl(null);
                  setShowModal("form-copy");
                } else {
                  toastMessage(
                    "warning",
                    "The form has no questions. Please add at least one question before copying"
                  );
                }
              }}
            >
              <ListItemText>Copy Form</ListItemText>
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              if (rowData.questionCount > 0) {
                setAnchorEl(null);
                setShowModal("save-template");
              } else {
                toastMessage(
                  "warning",
                  "The form has no questions. Please add at least one question saving the template"
                );
              }
            }}
          >
            <ListItemText>Save as Template</ListItemText>
          </MenuItem>
          {languages.length > 1 && (
            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                setShowModal("translation");
              }}
            >
              <ListItemText>View Translation</ListItemText>
            </MenuItem>
          )}
          {canExport && type === "study" && (
            <MenuItem onClick={() => handleExport()}>
              <ListItemText>Export Form</ListItemText>
            </MenuItem>
          )}
          {canEdit && rowData?.status === "draft" && (
            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                setShowDeleteModal(true);
              }}
            >
              <ListItemText sx={{ color: "#F05252" }}>Delete Form</ListItemText>
            </MenuItem>
          )}
        </Menu>
        {(showModal === "addForm" || showModal === "editForm") && (
          <AddScreeningFormModal
            showModal={!!showModal}
            closeModal={closeModal}
            data={rowData}
            refreshPage={refreshPage}
            phaseId={phaseId}
            formId={rowData?.formId || ""}
            type={type}
          />
        )}
        {showModal === "translation" && (
          <LanguageTranslationModal
            showModal={showModal === "translation"}
            closeModal={closeModal}
            studyId={studyId}
            formId={rowData?.formId}
            canEdit={canEdit}
          />
        )}
        {showModal === "form-copy" && (
          <CopyFormModal
            showModal={showModal === "form-copy"}
            closeModal={closeModal}
            studyId={studyId}
            data={rowData}
            refreshPage={refreshPage}
            formType={type}
          />
        )}
        {showModal === "save-template" && (
          <AddTemplateModal
            showModal={showModal === "save-template"}
            closeModal={closeModal}
            studyId={studyId}
            data={rowData}
            refreshPage={refreshPage}
            formId={rowData?.formId}
            type="screener"
            formType={type}
          />
        )}

        <DeleteConfirmModal
          title={"Delete Form ?"}
          description={deleteConfirmation.description}
          onOk={handleDelete}
          show={showDeleteModal}
          onClose={() => {
            setShowDeleteModal(false);
            handleMenuClose();
          }}
        />
      </Box>
    </Box>
  );
};

export default Screening;
